// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/routes/assessment/components/Card/style.scss
// module id = 740
// module chunks = 0